module.exports = __webpack_public_path__ + "img/product_60.35bc2fe.svg";